import { useBookingSubscription } from './useBookingSubscription';
import { useConversationSubscription } from './useConversationSubscription';
import { useNotificationSubscription } from './useNotificationSubscription';

export function useSubscriptions() {
  useBookingSubscription();
  useConversationSubscription();
  useNotificationSubscription();

  return null;
}
